module.exports = "<div class=order-wizard-modal-total-checked></div>";


//////////////////
// WEBPACK FOOTER
// ./src/utilities/productsModalUtilities/html/modalOrderFooterLeft.html
// module id = 1457
// module chunks = 1